import React from 'react';
import { Modal, Form, Input, InputNumber } from 'antd';

const AccountModal = ({ isVisible, onOk, onCancel, editingAccount, form }) => {
  return (
    <Modal
      title={editingAccount ? 'تعديل الحساب' : 'إضافة حساب'}
      open={isVisible}
      onOk={onOk}
      onCancel={onCancel}
      width="90%"
      style={{ maxWidth: 600 }}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="Name"
          label="Name"
          rules={[{ required: true, message: 'يرجى إدخال اسم الحساب!' }]}
        >
          <Input />
        </Form.Item>

      </Form>
    </Modal>
  );
};

export default AccountModal;
